module.exports = __webpack_public_path__ + "img/icon16.4189969d.png";